import { gql } from "@apollo/client";
export const GET_TIP_MENUS = gql`
  query Query($broadcaster: String, $tipMenu: String) {
    getTipMenus(broadcaster: $broadcaster) {
      broadcaster
      id
      name
      isActive
    }
    getTipMenuItems(tipMenu: $tipMenu) {
      amount
      id
      name
      tipMenu
      isActive
      isArchived
      bankByDefault
    }
  }
`;

export const GET_TIP_MENU_OVERLAPS = gql`
  query GetTipMenuOverlaps {
    getTipMenuOverlaps {
      amount
      keptMenu
      keptItem
      droppedMenu
      droppedItem
    }
  }
`;

export const GET_USER_SELECTED_MENU_ITEMS = gql`
  query getUserInfo {
    getUserInfo {
      selectedMenu
      activeMenus
      tipMenuItems {
        name
        amount
      }
    }
  }
`;
